type SellerReview = {
  reviewerFirstName: string;
  rating: 1 | 2 | 3 | 4 | 5;
  source: string;
  quote: string;
};

export const SELLER_REVIEWS: readonly SellerReview[] = [
  {
    reviewerFirstName: 'Ivana',
    rating: 5,
    source: 'Trustpilot',
    quote:
      'We hated having a lease and wanted to get out of it for so long but it was so expensive to do so. We felt so trapped but I took a chance on lease end and now we are FREE! They connected us with the sweetest dealership and it was completely painless! So happy with our experience here! Everyone was so helpful, kind, and professional!',
  },
  {
    reviewerFirstName: 'Jose',
    rating: 5,
    source: 'Trustpilot',
    quote:
      'My experience with lease end was more than great. Aaron was the one helping me through the process and was very patient and communicative with me the entire time. Lease end made getting rid of my lease super easy. 100% recommend it',
  },
  {
    reviewerFirstName: 'Peter',
    rating: 5,
    source: 'Trustpilot',
    quote:
      'You upload your information take a picture of your car and within a few days you get an offer and after that one or two weeks, everything is done. Highly recommended fantastic customer service thank you for getting me out of this bad bad deal.',
  },
  {
    reviewerFirstName: 'Matthew',
    rating: 5,
    source: 'Trustpilot',
    quote:
      'Communication was easy and straightforward. The transaction at the dealership who purchased my lease was simple, easy, informative and quicker than the line at In-N-Out!',
  },
  {
    reviewerFirstName: 'John',
    rating: 5,
    source: 'Trustpilot',
    quote:
      'Incredible service and support. The team at Lease End are pros in getting you out of your lease early in a pinch - not only fast but they save you a TON of money. I cannot recommend this company highly enough. Thank you for everything!',
  },
  {
    reviewerFirstName: 'Sergio',
    rating: 5,
    source: 'Trustpilot',
    quote:
      'This was a very quick and easy process. I was surprised at the quick and swift action. Thank you for your help.',
  },
  {
    reviewerFirstName: 'Patricia',
    rating: 4,
    source: 'Trustpilot',
    quote:
      'I had no idea I could get equity out of my lease. The process was easy. Lease End took care of all the paperwork, took my car and I received my check in the mail.',
  },
];
